// eslint-disable-next-line import-x/no-extraneous-dependencies
import { ILogger } from '@cian/logger';
import * as React from 'react';

interface IProps {
  offerId: number;
  logger: ILogger;
  extra?: { [key: string]: string };
}

export class ErrorBound extends React.Component<React.PropsWithChildren<IProps>> {
  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { logger, offerId, extra } = this.props;

    logger.error(error, {
      reactInfo: errorInfo.componentStack,
      offerId,
      url: location.href,
      referer: document.referrer,
      ...(extra || {}),
    });
  }

  public render() {
    return this.props.children;
  }
}
